import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useTenant } from '@/hooks/useTenant'
import { tenantKey } from '@/lib/queryClient'
import { securityApi } from './api'

export function useMfaStatus() {
  const tenantId = useTenant()
  return useQuery({
    queryKey: tenantKey(tenantId, 'security', 'mfa-status'),
    queryFn: securityApi.getMfaStatus,
  })
}

export function useReauthCognito() {
  return useMutation({
    mutationFn: (input: { email: string; password: string }) =>
      securityApi.reauthCognito(input.email, input.password),
  })
}

export function useAssociateTotp() {
  return useMutation({
    mutationFn: (input: { accessToken: string; email: string }) =>
      securityApi.associateTotp(input.accessToken, input.email),
  })
}

export function useMfaEnrollStart() {
  return useMutation({
    mutationFn: () => securityApi.mfaEnrollStart(),
  })
}

export function useVerifyTotp() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: (input: { accessToken: string; userCode: string; email: string }) =>
      securityApi.verifyTotp(input.accessToken, input.userCode, input.email),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'security', 'mfa-status') }),
  })
}

export function useMfaEnrollVerify() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: (input: { enrollmentToken: string; userCode: string }) =>
      securityApi.mfaEnrollVerify(input.enrollmentToken, input.userCode),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'security', 'mfa-status') }),
  })
}

export function useDisableTotp() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: (input: { userCode: string; password?: string }) =>
      securityApi.disableTotp(input.userCode, input.password),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'security', 'mfa-status') }),
  })
}
